const { toInt } = require('@/functions/transform');

/**
 * @constructor
 */
const TaxRegistration = function () {
    this.companyID = null;
    this.countryID = null;
    this.ID = null;
    this.registrationCode = null;
};

TaxRegistration.prototype = {
    getHydrationMap() {
        return {
            companyID: toInt,
            countryID: toInt,
            ID: {
                field: ['ID', 'taxRegistrationID'],
                transform: toInt,
            },
            registrationCode: {},
        };
    },
};

module.exports = TaxRegistration;
